var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconContentTypes = function SvgIconContentTypes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 111,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-content-types_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    x: 10,
    fill: "url(#icon-content-types_svg__b)",
    rx: 21,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-content-types_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.94 36.31c4.347 0 7.884-3.536 7.884-7.884-.396-10.445-15.374-10.442-15.77 0 .001 4.348 3.538 7.885 7.885 7.885Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0C0B0",
    d: "m69.841 34.716-8.158-14.132c-.435-.775-1.595-.775-2.03 0l-8.158 14.132c-.454.764.126 1.768 1.015 1.757h16.317c.889.011 1.469-.993 1.014-1.757Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M67.553 41.982H53.746c-.647 0-1.172.525-1.172 1.172v13.807c0 .647.525 1.172 1.172 1.172h13.807c.647 0 1.172-.525 1.172-1.172V43.154c0-.647-.525-1.172-1.172-1.172Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0C0B0",
    d: "M40.768 40.462a1.172 1.172 0 0 0-1.657 0l-8.768 8.767a1.172 1.172 0 0 0 0 1.658l8.768 8.767c.458.458 1.2.458 1.657 0l8.768-8.767c.457-.458.457-1.2 0-1.657l-8.768-8.768Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-content-types_svg__b",
    x1: 10,
    x2: 90,
    y1: 58,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F56C4E",
    stopOpacity: 0.84
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-content-types_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30 20h40v40H30z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon-content-types_svg__a",
    width: 100,
    height: 111,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 11,
    result: "effect1_dropShadow_641_735767"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 21
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.9125 0 0 0 0 0.713268 0 0 0 0 0.585521 0 0 0 0.59 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_641_735767"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_641_735767",
    result: "shape"
  })))));
};
export default SvgIconContentTypes;